import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from "@angular/core";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";

@Component({
	selector: "obg-m-multi-deposit-limit-step",
	styleUrls: ["./multi-deposit-limit-step.container.scss"],
	templateUrl: "./multi-deposit-limit-step.container.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class MultiDepositLimitStepContainer {
	@HostBinding("class.obg-m-multi-deposit-limit-step") hostCssClass = true;

	constructor(private matDialog: MatDialog) {}

	onNavigate() {
		return this.matDialog.closeAll();
	}
}
